import { render, staticRenderFns } from "./FormPrincipalAssociante.vue?vue&type=template&id=6d148385"
import script from "./FormPrincipalAssociante.vue?vue&type=script&lang=js"
export * from "./FormPrincipalAssociante.vue?vue&type=script&lang=js"
import style0 from "./FormPrincipalAssociante.vue?vue&type=style&index=0&id=6d148385&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports